<!-- =========================================================================================
  File Name: FormWizardValidation.vue
  Description: Form wizard with validation
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <vx-card
          v-if="orderType == 'Equipamento Revenda'"
          icon="DollarSignIcon"
          icon-right
          :title="orderType"
          title-color="#fff"
          card-background="success"
          content-color="#fff"
        >
          <p class="mb-3">
            Você está inserindo um <strong>{{text}} </strong> de <strong>{{ orderType }}</strong>
          </p>
        </vx-card>
        <vx-card
          v-if="orderType == 'Equipamento Venda Direta'"
          :title="orderType"
          title-color="#fff"
          card-background="#9ACD32"
          content-color="#fff"
        >
          <p class="mb-3">
           Você está inserindo um <strong>{{text}} </strong> de <strong>{{ orderType }}</strong>
          </p>
        </vx-card>
        <vx-card
          v-if="orderType == 'Suprimentos'"
          :title="orderType"
          title-color="#fff"
          card-background="#1E90FF"
          content-color="#fff"
        >
          <p class="mb-3">
            Você está inserindo um <strong>{{text}} </strong> de <strong>{{ orderType }}</strong>
          </p>
        </vx-card>
        <vx-card
          v-if="orderType == 'Mídias'"
          :title="orderType"
          title-color="#fff"
          card-background="#1E90FF"
          content-color="#fff"
        >
          <p class="mb-3">
            Você está inserindo um <strong>{{text}} </strong> de <strong>{{ orderType }}</strong>
          </p>
        </vx-card>
        <vx-card
          v-if="orderType == 'Mão de Obra'"
          :title="orderType"
          title-color="#fff"
          card-background="warning"
          content-color="#fff"
        >
          <p class="mb-3">
            Você está inserindo um <strong>{{text}} </strong> de <strong>{{ orderType }}</strong>
          </p>
        </vx-card>
        <vx-card
          v-if="orderType == 'Peças'"
          :title="orderType"
          title-color="#fff"
          card-background="danger"
          content-color="#fff"
        >
          <p class="mb-3">
            Você está inserindo um <strong>{{text}} </strong> de <strong>{{ orderType }}</strong>
          </p>
        </vx-card>
        <vx-card
          v-if="orderType == 'Suprimentos Locação'"
          :title="orderType"
          title-color="#fff"
          card-background="dark"
          content-color="#fff"
        >
          <p class="mb-3">
            Você está inserindo um <strong>{{text}} </strong> de <strong>{{ orderType }}</strong>
          </p>
        </vx-card>
        <vx-card
          v-if="orderType == 'Locação'"
          :title="orderType"
          title-color="#fff"
          card-background="primary"
          content-color="#fff"
        >
          <p class="mb-3">
           Você está inserindo um <strong>{{text}} </strong> de <strong>{{ orderType }}</strong>
          </p>
        </vx-card>
        <vx-card
          v-if="orderType == 'Ouro'"
          :title="orderType"
          title-color="#fff"
          card-background="warning"
          content-color="#fff"
        >
          <p class="mb-3">
            Você está inserindo um <strong>{{text}} </strong> de <strong>{{ orderType }}</strong>
          </p>
        </vx-card>
      </div>
    </div>
  </div>
</template>
<script>
import StatisticsCardLine from "@/components/statistics-cards/StatisticsCardLine.vue";
export default {
  components: {
    StatisticsCardLine,
  },
  props: {
    orderType: {
      type: String,
    },
     text: {
      type: String,
      default: 'Não definido' 

    },
  },
  data() {
    return {};
  },
  created() {},
};
</script>
